module.exports = __webpack_public_path__ + "static/img/4.e01ba62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-fr/4.jpg
// module id = mjUx
// module chunks = 1